<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <div class="footer-brand">
        <router-link to="/index" class="footer-brand-link">
          <img src="/vfront/img/logo.png" alt="InnoSource" class="footer-logo" />
          <div>
            <strong>InnoSource</strong>
            <p>Connect Ideas with Reliable Technology</p>
          </div>
        </router-link>
      </div>

      <div class="footer-links">
        <h5>Navigation</h5>
        <ul>
          <li><router-link to="/service">サービス</router-link></li>
          <li><router-link to="/business">事業案内</router-link></li>
          <li><router-link to="/technology">技術分野</router-link></li>
          <li><router-link to="/recruit">採用情報</router-link></li>
        </ul>
      </div>

      <div class="footer-links">
        <h5>Company</h5>
        <ul>
          <li><router-link to="/message">代表挨拶</router-link></li>
          <li><router-link to="/philosophy">経営理念</router-link></li>
          <li><router-link to="/history">会社沿革</router-link></li>
          <li><router-link to="/profile">会社概要</router-link></li>
        </ul>
      </div>

      <div class="footer-contact">
        <h5>Contact</h5>
        <p>info@innosource.co.jp</p>
        <p>〒850-0035 長崎県長崎市元船町9-18 2階</p>
      </div>
    </div>

    <div class="footer-copyright">
      <p>© Copyright 2026 InnoSource. All Rights Reserved.</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'foot',
};
</script>
